import { render, staticRenderFns } from "./customerDetail.vue?vue&type=template&id=3a07d75f"
import script from "./customerDetail.vue?vue&type=script&lang=js"
export * from "./customerDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports